import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'Is this audio going to tell me my insomnia is "all in my head"?',
  answer: "No. The Taproot Protocol helps you identify YOUR specific structural root, whether it's physiological, behavioral, environmental, or psychological. This isn't a generic answer, it's a diagnostic method."
}, {
  question: "I've already done root cause analysis with my doctor. How is this different?",
  answer: "Most root cause analysis stops at the first plausible cause (poor sleep hygiene, elevated cortisol, anxiety). The Taproot Protocol keeps descending past those secondary causes to the structural root beneath them. It's the difference between treating A cause versus treating THE cause."
}, {
  question: 'How long is the audio?',
  answer: '40 minutes.'
}, {
  question: 'Will this cure my insomnia?',
  answer: "This audio is diagnostic, not prescriptive. It helps you identify what you're actually dealing with. Once you know your true root, the solution often becomes obvious. But this isn't a medical treatment or guarantee."
}, {
  question: 'Can I listen to this while trying to fall asleep?',
  answer: "No. This isn't a sleep meditation. This is an investigative audio that requires active listening. Listen during a commute, a walk, or dedicated focus time."
}, {
  question: 'What if my insomnia really is caused by multiple different problems?',
  answer: 'That\'s what the Symptom Cascade makes you think. The Taproot Protocol reveals how what looks like "multiple roots" is almost always one structural root with multiple branches. This is the entire insight: you\'re not as complicated as your symptom list makes you seem.'
}, {
  question: 'Do I need any special equipment or knowledge?',
  answer: 'No. Just headphones or speakers and 40 minutes of focused listening time.'
}, {
  question: 'Is there a catch?',
  answer: 'No. $7 is the full price. No upsells. No subscription. No hidden costs.'
}, {
  question: 'Can I share this with my partner or family?',
  answer: 'Yes. If this perspective helps you, share it with whoever needs to hear it.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section background="night-950" className="pb-32" data-id="element-1">
      <h2 className="font-serif text-3xl md:text-4xl text-white mb-12 text-center" data-id="element-2">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-3">
        {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-lg bg-night-900 overflow-hidden" data-id="element-4">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-5">
              <span className="font-medium text-white pr-8" data-id="element-6">
                {faq.question}
              </span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold-500 flex-shrink-0" data-id="element-7" /> : <ChevronDown className="w-5 h-5 text-gold-500 flex-shrink-0" data-id="element-8" />}
            </button>

            <AnimatePresence data-id="element-9">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-10">
                  <div className="px-6 pb-6 text-slate-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-11">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>

      <div className="mt-24 text-center max-w-2xl mx-auto" data-id="element-12">
        <p className="font-serif text-xl text-white italic mb-4" data-id="element-13">
          "If this way of looking at chronic problems resonates with you, the
          audio will make sense. If you're looking for techniques, supplement
          protocols, or quick fixes, it probably won't."
        </p>
        <p className="text-slate-400 mb-8" data-id="element-14">That's intentional.</p>
        <div className="text-gold-500 font-serif text-lg" data-id="element-15">— Sarah Mitchell</div>
        <div className="text-slate-500 text-sm" data-id="element-16">
          Health & Wellness Consultant
        </div>
      </div>
    </Section>;
}